import { BaseMapper } from '@ps/utils';
import { UploadPsidFileResult } from '@ps/survey-utils';

import { UploadPsidFileResponseDto } from '../dtos/upload-psid-file.dto';

export class UploadPsidFileMapper extends BaseMapper<
  UploadPsidFileResponseDto,
  UploadPsidFileResult
> {
  public fromDto(dto: UploadPsidFileResponseDto): UploadPsidFileResult {
    return {
      filePath: dto.data.filePath,
      uniqPsidCount: dto.data.uniq_psid,
      uploadedPsidCount: dto.data.uploaded_psid,
    };
  }
}
